import {TheRaveSymbol} from "./TheRaveSymbol";
import {TheRaveSymbolState} from "./TheRaveSymbolConfig";
import {TimelineLite} from "gsap";
import {TheRave} from "../TheRave";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {TheRaveSound} from "../sound/TheRaveSound";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Helper} from "../../core/utils/Helper";

export class TheRaveScatterSymbol extends TheRaveSymbol {
    private _animationContainer: PIXI.Container | null;
    private _symbolSpine: PIXI.spine.Spine;
    private _symbolSpineBlend: PIXI.spine.Spine;
    private _symbolSpineTop: PIXI.spine.Spine;
    private _symbolSpineBlendTop: PIXI.spine.Spine;

    public get animationContainer():PIXI.Container | null{
        return this._animationContainer;
    }
    constructor(symbolName: string, reelId: number, initState: TheRaveSymbolState, symHeight: number = 150, linkedNum: number = 1) {
        super(symbolName, reelId, initState, symHeight);
        this._animationContainer = new PIXI.Container();
    }

    protected updateLayers() {
        if (this && this._symbolSpine) {
            const layer:StageLayer = TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)!;
            this._symbolSpine.visible = false;
            this._symbolSpineBlend.visible = false;
            this._symbolSpineTop.visible = false;
            this._symbolSpineBlendTop.visible = false;
            if(!this._animationContainer){
                this._animationContainer = new PIXI.Container();
            }
            layer.addChild(this._animationContainer!);
            this._animationContainer!.position = Helper.copyLocalPosition(this._animationContainer!,this);
            this._animationContainer!.position.y -= (TheRave.model.isFreespin?40:0);
        }
    }

    private removeSpine(): void {
        if (this && this._symbolSpine) {
            this._symbolSpine.destroy();
            this._symbolSpineBlend.destroy();
            this._symbolSpineTop.destroy();
            this._symbolSpineBlendTop.destroy();
        }
    }

    private addSpine(name: string): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(name));
        spine.name = name;
        spine.autoUpdate = true;
        spine.position.set(0, 0);
        spine.visible = false;
        if(!this._animationContainer){
            this._animationContainer = new PIXI.Container();
        }
        this._animationContainer.addChild(spine);
        return spine;
    }

    public onRemove() {
        this.removeSpine();
        if(this && this._animationContainer){
            TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)!.removeChild(this._animationContainer);
            this._animationContainer = null;
        }
        super.onRemove();
    }

    private prepareSpine(): void {
        if (this && this._symbolSpine) {
            return;
        }
        this._symbolSpine = this.addSpine(`scatterNORMAL`);
        this._symbolSpineBlend = this.addSpine(`scatterBLEND`);
        this._symbolSpineBlendTop = this.addSpine(`scatterBLENDTOP`);
        this._symbolSpineTop = this.addSpine(`scatterNORMALTOP`);
    }

    public playLanding(init: boolean = false, index: number = 1): TimelineLite {
        this.prepareSpine();
        this.updateLayers();
        const soundName: string = (TheRave.model.isFreespin ? "scatter5" : (TheRaveSound.SCATTER_LANDING[index - 1]));
        TheRaveSound.playSoundEffect(soundName);
        this._symbolSpineTop.state.setAnimation(0, `${index === 1 ? "first" : "second"}`, false);
        this._symbolSpineTop.visible = true;

        if (index > 1) {
            this._symbolSpineBlend.visible = true;
            this._symbolSpineBlendTop.visible = true;
            this._symbolSpineBlend.state.setAnimation(0, `second`, false);
            this._symbolSpineBlendTop.state.setAnimation(0, `loop`, false);
        }
        return new TimelineLite();
    }

    public playEnhancerFrame(): void {
        new TimelineLite().add(() => {
            if (this && this._symbolSpineBlend) {
                this._symbolSpineBlend.destroy();
                this._symbolSpineTop.destroy();
                this._symbolSpineBlend = this.addSpine(`scatterBLEND`);
                this._symbolSpineTop = this.addSpine(`scatterNORMALTOP`);
            }
            this.updateLayers();
            this._symbolSpineBlend.state.setAnimation(0, "loop", true);
            this._symbolSpineTop.state.setAnimation(0, `loop`, true);
            this._symbolSpineBlend.visible = true;
            this._symbolSpineTop.visible = true;
            this._symbolSpine.visible = true;
        }, 0.6);
    }
}